import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	inject,
	OnDestroy,
	OnInit,
} from '@angular/core';
import { ICmmsFilter } from '@app/pages/cmms/components/cmms-sort-filters-grouping/interfaces-and-types/filter.interfaces';
import { Subject } from 'rxjs';
import { CmmsFiltersService } from '@app/pages/cmms/components/cmms-sort-filters-grouping/services/cmms-filters.service';
import { map, takeUntil } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { AuPipesModule } from '@shared/pipes/au-pipes.module';
import { MatIconModule } from '@angular/material/icon';
import { AuSearchInputComponent } from '@app/shared/ui-components/au-search-input/au-search-input.component';
import { NgxTolgeeModule } from '@tolgee/ngx';

@Component({
	selector: 'filter-list-menu',
	templateUrl: './filter-list-menu.component.html',
	styleUrls: ['./filter-list-menu.component.scss'],
	imports: [
		CommonModule,
		AuSearchInputComponent,
		AuPipesModule,
		MatIconModule,
		NgxTolgeeModule,
	],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterListMenuComponent implements OnInit, OnDestroy {
	private readonly filterService = inject(CmmsFiltersService);
	private readonly cdr = inject(ChangeDetectorRef);
	filterTypeIcons!: { [key: string]: string };
	searchText: string;

	availableFilters: ICmmsFilter[] = [];

	private destroy$ = new Subject<void>();

	ngOnInit(): void {
		this.filterTypeIcons = this.filterService.filterTypeIcons;
		this.subscribeToAvailableFilters();
	}

	subscribeToAvailableFilters(): void {
		this.filterService.filterList$
			.pipe(
				takeUntil(this.destroy$),
				map(filters => {
					return filters.filter(filter => filter.name !== 'Title');
				})
			)
			.subscribe((filters: ICmmsFilter[]) => {
				this.availableFilters = filters;
				this.cdr.markForCheck();
			});
	}

	selectFilter(filter: ICmmsFilter): void {
		this.filterService.addFilterToSelection([filter]);
		if (this.searchText?.length) {
			this.searchText = '';
		}
	}

	ngOnDestroy() {
		this.destroy$.next();
		this.destroy$.complete();
	}
}
